import React from 'react';
import BoletoIcon from '../../../icons/payment/BoletoIcon';
import type { BoletoActionsProps } from '../types/boleto-payment.types';

const BoletoActions: React.FC<BoletoActionsProps> = ({ pdfUrl }) => {
  return (
    <></>
  );
};

export default BoletoActions; 